import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid1x3Vertical: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDotGrid1x3Vertical"><Path d="M14 2H10V6H14V2Z" fill="currentColor"/><Path d="M14 10H10V14H14V10Z" fill="currentColor"/><Path d="M14 18H10V22H14V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid1x3Vertical;
